import React, { useEffect, useState } from "react";
import CCLogo from "../../../assets/img/cc-logo.png"; // Adjust path as needed

const TOTAL_MAINTENANCE_TIME = 15 * 60 * 1000; // 15 minutes in milliseconds

const MaintenanceModal = ({ show, message, resetTimestamp }) => {
  const [timeLeft, setTimeLeft] = useState("15:00");
  const [progress, setProgress] = useState(100);

  const contentContainerStyle = {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const headingStyle = {
    fontWeight: 'bold',
    marginBottom: "1rem",
    marginTop: "20px",
    textAlign: "center",
    fontSize: "22px"
  };

  const messageStyle = {
    fontSize: '1.2rem',
    marginBottom: '2rem',
    maxWidth: '600px',
    lineHeight: '1.5',
  };

  useEffect(() => {
    if (!show || !resetTimestamp) return;

    document.body.style.overflow = "hidden";
    document.body.classList.add("blur-background");

    const interval = setInterval(() => {
      const now = Date.now();
      const remaining = resetTimestamp - now;
      const percentLeft = Math.max((remaining / TOTAL_MAINTENANCE_TIME) * 100, 0);

      if (remaining <= 0) {
        setTimeLeft("00:00");
        setProgress(0);
        clearInterval(interval);
      } else {
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
        setTimeLeft(`${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`);
        setProgress(percentLeft);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
      document.body.style.overflow = "auto";
      document.body.classList.remove("blur-background");
    };
  }, [show, resetTimestamp]);

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        backdropFilter: "blur(5px)",
        zIndex: 1055
      }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div
          className="modal-content shadow-lg border-0"
          style={{
            width: "90vw",
            maxWidth: "800px",
            minHeight: "300px",
            borderRadius: "20px",
            padding: "1.5rem"
          }}
        >
          <div className="modal-body">
          <div style={contentContainerStyle}>
          <div className="col-12 text-center mb-3 mb-md-0">
                <img
                  src={CCLogo}
                  alt="Logo"
                  style={{"width":"180px"}}
                  className="img-fluid"
                />
              </div>
            {/* <h1 style={headingStyle}>We'll Be Back Soon!</h1> */}
            <p style={headingStyle}>
            Apologies - our AI is currently undergoing an update. <br/>Please check back soon.{' '}
            </p>
          </div>
            {/* <div className="column align-items-center text-center">
              <div className="col-12 col-md-5 text-center mb-3 mb-md-0">
                <img
                  src={CCLogo}
                  alt="Logo"
                  className="img-fluid"
                />
              </div>
              <div className="col-12 col-md-7">
                <h4 className="fw-bold mb-2" style={{"color":'#cc4173'}}>🚧  Maintenance</h4>
                <p className="text-dark mb-2" style={{ fontSize: "1rem" }}>
                  {message || "Our AI servers are currently not responding. Please try again after some time."}
                </p>
                <p className="text-muted mb-1">
                  ⏳ <strong className="text-primary">{timeLeft}</strong> remaining
                </p>
                <small className="text-secondary">Auto-retrying after countdown...</small>

                <div className="d-flex align-items-center gap-2 mt-3">
                  <div
                    className="spinner-border"
                    role="status"
                    style={{ width: "1.5rem",color:"#25C9D0", height: "1.5rem" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span className="text-muted">System resuming soon...</span>
                </div>
                <div className="progress mt-4" style={{ height: "8px" }}>
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ background:'#25C9D0', width: `${progress}%` }}
                  ></div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceModal;
